import { ITranslationEditItem } from './ITranslationEditItem';

export interface ISurveyTermItemEditModel extends ISurveyTermItemKey {
	term?: ITranslationEditItem;
	description?: ITranslationEditItem;
	deleted?: boolean;
}

export interface ISurveyTermItemAddModel extends ISurveyTermItemKey {
	surveyId: number;
}

export enum SurveyTermItemEditFieldType {
	SURVEY_DEFINITION_TERM = 'SURVEY_DEFINITION_TERM',
	SURVEY_DEFINITION_DESCRIPTION = 'SURVEY_DEFINITION_DESCRIPTION',
}

export interface ISurveyTermItemKey {
	surveyTermItemId: number;
	sequence: number;
}

export interface ISurveyTermItemChangeModel extends ISurveyTermItemKey {
	defaultCultureCode: string;
	surveyTermItemEditFieldType: SurveyTermItemEditFieldType;
	surveyTermItemEditValue: string;
}

export interface ISurveyTermSwitchUpdateMode {
	checked: boolean;
	initialValue: ISurveyTermItemEditModel[];
}
